import { initializeApp } from "firebase/app";
import {
  getFirestore,
  doc,
  getDoc,
  connectFirestoreEmulator,
} from "firebase/firestore";

const USER_INPUTS = "userInputs";

const app = initializeApp({
  apiKey: "AIzaSyAqUu694nsYCY7AymW4dtmQLGeqiIHY6IM",
  authDomain: "thermal-point.firebaseapp.com",
  projectId: "thermal-point",
  storageBucket: "thermal-point.firebasestorage.app",
  messagingSenderId: "579368637697",
  appId: "1:579368637697:web:46fc872502ac04269e7700",
  measurementId: "G-0ER8SDH5XH",
});

let db;

function getDb() {
  if (db) return db;

  db = getFirestore(app);

  const emulatorHost = process.env.REACT_APP_FIRESTORE_EMULATOR_HOST;
  if (process.env.NODE_ENV === "development" && emulatorHost) {
    const [host, port] = emulatorHost.split(":");
    connectFirestoreEmulator(db, host, Number(port) || 8080);
  }

  return db;
}

export async function fetchCalculationResult(resultId) {
  const snap = await getDoc(doc(getDb(), USER_INPUTS, String(resultId)));

  if (!snap.exists()) {
    const err = new Error("Results not found.");
    err.code = "not-found";
    throw err;
  }

  const { data, result_id: storedId } = snap.data() ?? {};
  if (!data || typeof data !== "object") {
    const err = new Error("Results data is missing.");
    err.code = "invalid-data";
    throw err;
  }

  return { ...data, result_id: storedId ?? resultId };
}
